import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=707f8df4&scoped=true&"
import script from "./Offer.vue?vue&type=script&lang=js&"
export * from "./Offer.vue?vue&type=script&lang=js&"
import style0 from "./Offer.vue?vue&type=style&index=0&id=707f8df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707f8df4",
  null
  
)

export default component.exports